import { SearchPageRefreshText } from '@studyportals/search-page-interface';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import store from '@/study-search/store';
import { ParsedFilter } from '@/study-search/models/generalizations/ParsedFilter';
import { ParameterType } from '@studyportals/search-interface-ts';

export default class RefreshTextPlugin implements ISubscriber<SearchPageRefreshText> {
	public initiate(): void {
		const eventAggregationService = window.EventAggregationService;
		if (!eventAggregationService) return;

		eventAggregationService.subscribeTo(SearchPageRefreshText.EventType, this, true);
	}

	public notify({ text }: SearchPageRefreshText): void {
		const filters: ParsedFilter[] = text ? [new ParsedFilter(ParameterType.KEYWORD_WHAT, [text])] : [];

		void store.actions.processAutocompleteInput(
			{
				filters
			},
			true
		);
	}
}
